
import mobileIOS from './mobileIOS'
import mobileAndroid from './mobileAndroid'

export default { mobileIOS , mobileAndroid } 
